import { useEffect } from 'react'
import { Layout } from 'antd'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useLocation } from 'react-router-dom'
import HeaderModule from './Components/Header/HeaderModule'
import FooterModule from './Components/Footer/FooterModule'
import { ModalsAggregator } from './Components/Modals/ModalsAggregator'
import { useModalStore } from './store/ModalStore'
import { MODAL_STATE } from './types/modals'
import { hasCookieConsent } from './utils/cookieUtils'
import { usePageTitle } from './hooks/usePageTitle'
import './App.css'
import AppRoutes from './Routes/AppRoutes'
import ScrollToTop from './Components/Common/ScrollToTop'

// Google reCAPTCHA Site Key
// Replace with your actual site key from https://www.google.com/recaptcha/admin
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY!

const { Content } = Layout

function App() {
    const { openModal } = useModalStore()
    const location = useLocation()
    usePageTitle()

    useEffect(() => {
        // Check if cookie consent has been given on app load
        // Only run once on mount to prevent reCAPTCHA timeout issues
        const checkCookieConsent = () => {
            try {
                const isOnCookiesPage =
                    location.pathname === '/privacy' &&
                    location.hash === '#cookies'

                if (!hasCookieConsent() && !isOnCookiesPage) {
                    openModal(MODAL_STATE.COOKIE_CONSENT)
                }
            } catch (error) {
                console.error('Error checking cookie consent:', error)
            }
        }
        checkCookieConsent()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, location.hash])

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={RECAPTCHA_SITE_KEY}
            scriptProps={{
                async: true,
                defer: true,
                appendTo: 'body',
                nonce: undefined,
            }}
        >
            <Layout style={{ minHeight: '100vh' }}>
                <ScrollToTop />

                <HeaderModule />

                <Content className="content">
                    <AppRoutes />
                </Content>

                <FooterModule
                    onContactUsClick={() => openModal(MODAL_STATE.CONTACT_US)}
                />
            </Layout>

            <ModalsAggregator />
        </GoogleReCaptchaProvider>
    )
}

export default App
